import React from "react";
import { registrarErrorFrontend } from "../../services/frontendErrorLogger";
import { Box, Typography, Button, Paper } from "@mui/material";

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        registrarErrorFrontend({
            name: error?.name || "REACT_ERROR_BOUNDARY",
            message: error?.message || "Error al renderizar componente",
            stack: `${error?.stack || ""}\nComponent Stack: ${errorInfo?.componentStack || ""}`,
        }, "REACT_RENDER");
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{ p: 4, display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" }}>
                    <Paper elevation={3} sx={{ p: 4, maxWidth: 600, textAlign: "center" }}>
                        <Typography variant="h5" color="error" gutterBottom>
                            Ocurrió un problema inesperado en esta vista
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            {this.state.error?.message || "Ha ocurrido un error inesperado al procesar la información."}
                        </Typography>
                        <Button variant="contained" color="primary" onClick={this.handleReload}>
                            Recargar página
                        </Button>
                    </Paper>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;

